import { render, staticRenderFns } from "./CellDuration.vue?vue&type=template&id=70554f4b&"
import script from "./CellDuration.vue?vue&type=script&lang=ts&"
export * from "./CellDuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports